import axios from 'axios';


export default {
    async GetFavoriteEmployees(activeSiteIds) {
        return axios
            .post(
                process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
                '/api/my-page/favorites/employees',
                activeSiteIds
            )
            .then((res) => {
                if (res.data && res.data.responseCode === 200) {
                    return res.data.employeeList;
                } else {
                    return null;
                }
            })
            .catch(function () {
                return {};
            });
    },
    async UpdateFavoriteEmployees(employeeId) {
        return axios
            .post(
                process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
                '/api/my-page/favorites/employees/update',
                {
                    employeeId: employeeId,
                }
            )
            .then((res) => {
                if (res) {
                    return res;
                } else {

                    return null;
                }
            })
            .catch(function () {
                return {};
            });
    },
    async GetFavoriteProducts(activeSiteIds) {
        return axios
            .post(
                process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
                '/api/my-page/favorites/products',
                activeSiteIds
            )
            .then((res) => {
                if (res.data && res.data.responseCode === 200) {
                    return res.data.array;
                } else {
                    return null;
                }
            })
            .catch(function () {
                return {};
            });
    },
    async UpdateFavoriteProducts(productId, activeSiteIds) {
        return axios.post(
            process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
            '/api/my-page/favorites/products/update',
            {
                productId: productId,
                siteId: activeSiteIds[0].toString(),
            }
        )
            .then(async (res) => {
                if (res) {
                    return await this.GetFavoriteProducts(activeSiteIds);
                } else {

                    return null;
                }
            })
            .catch(function () {
                return {};
            });
    },
    async GetFavoriteTreatments(activeSiteIds) {
        return await axios
            .post(
                process.env.VUE_APP_FIXIT_NO_BOOKING_URL +
                '/api/my-page/favorites/treatments',
                activeSiteIds
            )
            .then((res) => {
                if (res.data && res.data.responseCode === 200) {
                    return res.data.array;
                } else {
                    return null;
                }
            })
            .catch(function () {
                return {};
            });
    }
};
